<!--
 * @Author: cryi.liu
 * @Date: 2020-06-10 17:48:00
 * @LastEditTime: 2020-06-16 17:41:54
 * @Description: 答题预览
-->
<template>
  <div class="preview">
    <div class="paper-info">
      <p v-for="(item, index) in libraryInfo"
        :key="index"
        :style="{ color: item.answer && item.answer !== '' ? '' : 'red' }">
        题目{{ index + 1 }}：{{ item.answer && item.answer !== '' ? '已答题' : '未答题' }}
      </p>
    </div>
    <div class="button">
      <p>答案只能提交一次，确认提交之后，将不能参加本次考试</p>
      <div>
        <pss-button class="back" text="返回考试" @on-click="backPaper" />
        <pss-button text="确认提交" @on-click="handlerSubmit" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PreviewAnswerDetail',
  props: {
    libraryInfo: { type: Array, required: true },
  },
  methods: {
    backPaper() {
      this.$emit('back-paper');
    },
    handlerSubmit() {
      if (window.confirm('确认提交试卷吗？')) {
        this.$emit('handler-submit');
      }
    },
  },
};
</script>

<style lang="less" scoped>
.button {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  > p {
    margin-bottom: 10px;
    color: red;
    font-weight: bold;
  }
  .back {
    margin-right: 35px;
  }
}
</style>
